<script lang="ts">
	interface Props {
		selected?: boolean;
		classes?: string;
		children?: import('svelte').Snippet;
		onclick?: (event: MouseEvent) => void;
	}

	let { selected = false, classes = '', children, onclick }: Props = $props();
	const defaultClasses = 'rounded-[7px] sm:py-[6px] transition-colors';
</script>

{#if selected}
	<button {onclick} class="{classes} {defaultClasses} btn bg-primary-500 text-white">
		{@render children?.()}
	</button>
{:else}
	<button
		{onclick}
		class="{classes} {defaultClasses} btn border border-surface-300-700 bg-surface-50 dark:bg-surface-50 text-surface-900 hover:brightness-110! dark:hover:brightness-110!"
	>
		{@render children?.()}
	</button>
{/if}
